import React from "react";
import { InputNumber as NumberInput } from "antd";
import styles from "./index.module.css";

function sanitizeValue(value, maxDecimals) {
  if (value === null || value === undefined) return "";
  let v = String(value);
  // Replace commas with dots
  v = v.replace(",", ".");
  // If contains more than one dot, keep first
  const parts = v.split(".");
  const intPart = parts.shift().replace(/[^0-9-]/g, "");
  let decPart = parts.join("");
  if (maxDecimals === 0) {
    return intPart;
  }
  if (decPart.length > maxDecimals) {
    decPart = decPart.slice(0, maxDecimals);
  }
  return decPart.length > 0 ? `${intPart}.${decPart}` : intPart;
}

const InputNumber = ({
  className = "",
  decimals = 0,
  onChange,
  value,
  formatter,
  ...props
}) => {
  const handleChange = (value) => {
    const sanitized = sanitizeValue(value, decimals);
    onChange(sanitized);
  };

  const defaultFormatter = (value) => value.replace(".", ",");

  return (
    <NumberInput
      className={`${styles.numberField} ${className}`}
      value={value}
      onChange={handleChange}
      precision={2}
      decimalSeparator=","
      formatter={formatter || defaultFormatter}
      {...props}
    />
  );
};

export default InputNumber;
